/*
 * Ant Design v5 theme for SMILEconceal — the warm DARK look from the design
 * proposal. Mirrors styles/design-tokens.css. Built on darkAlgorithm, then
 * pulled warm (near-black brown ground, one orange accent) so it matches the
 * token-driven kit used across every screen.
 */
import { theme } from 'antd';

const SANS =
  "-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif";

export const antdTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    // brand + semantic
    colorPrimary: '#F0812E',
    colorSuccess: '#3BB584',
    colorError: '#E56A6A',
    colorInfo: '#6FA0CE',
    colorWarning: '#D9A44B',
    colorLink: '#F5A25E',
    // warm dark grounds + text
    colorTextBase: '#F3EEE4',
    colorBgBase: '#151209',
    colorBgLayout: '#151209',
    colorBgContainer: '#201C15',
    colorBgElevated: '#282216',
    colorText: '#F3EEE4',
    colorTextSecondary: '#B2A995',
    colorTextTertiary: '#7E7561',
    colorBorder: '#262017',
    colorBorderSecondary: '#2A2417',
    colorFillQuaternary: '#282216',
    // geometry + type
    borderRadius: 10,
    borderRadiusLG: 14,
    borderRadiusSM: 8,
    controlHeight: 38,
    fontFamily: SANS,
    fontSize: 14,
    lineHeight: 1.55,
    // deep, soft elevation
    boxShadow: '0 1px 2px rgba(0,0,0,.4)',
    boxShadowSecondary: '0 4px 16px rgba(0,0,0,.45)',
    wireframe: false,
  },
  components: {
    Button: { primaryShadow: '0 1px 2px rgba(0,0,0,.4)', defaultColor: '#B2A995', defaultBorderColor: '#352E20' },
    Card: { headerFontSize: 15, headerBg: 'transparent', paddingLG: 22, colorBorderSecondary: '#262017' },
    Segmented: { trackBg: '#2A2417', itemSelectedBg: '#3A3220', itemColor: '#B2A995', itemSelectedColor: '#F3EEE4', trackPadding: 3, borderRadius: 10 },
    Table: { headerBg: '#282216', headerColor: '#7E7561', rowHoverBg: '#282216', borderColor: '#262017', cellPaddingBlock: 12, headerSplitColor: 'transparent', colorBgContainer: '#201C15' },
    Input: { activeBorderColor: '#F0812E', hoverBorderColor: '#352E20', activeShadow: '0 0 0 3px rgba(240,129,46,.18)', colorBorder: '#352E20', colorBgContainer: '#201C15' },
    InputNumber: { activeBorderColor: '#F0812E', hoverBorderColor: '#352E20', colorBorder: '#352E20', colorBgContainer: '#201C15' },
    Select: { optionSelectedBg: '#3A2915', optionSelectedColor: '#F5A25E', colorBorder: '#352E20', colorBgContainer: '#201C15' },
    AutoComplete: { colorBgContainer: '#201C15' },
    Tabs: { inkBarColor: '#F0812E', itemSelectedColor: '#F3EEE4', itemActiveColor: '#F3EEE4', titleFontSize: 14 },
    Steps: { colorPrimary: '#F0812E' },
    Alert: { colorInfoBg: '#152230', colorInfoBorder: '#25384A' },
    Modal: { borderRadiusLG: 16 },
    Progress: { defaultColor: '#F0812E' },
    Statistic: { titleFontSize: 12 },
    Collapse: { headerBg: 'transparent', colorBorder: '#262017' },
    Popover: { colorBgElevated: '#282216' },
    Tooltip: { colorBgSpotlight: '#2E2718', colorTextLightSolid: '#F3EEE4' },
  },
};

export default antdTheme;
